import React, {useState, useEffect, useRef} from 'react';
import AppAdminUsersListItem from "./AppAdminUsersListItem.mjs";
import { useCTAL } from './CTAL_Hooks.js';

export default function AppAdminUsersList() 
{
    const { app_admin_users_list, setAppAdminUsersList, app_admin_users_refresh, setAppAdminUsersRefresh } = useCTAL();
    
    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    
    const initRef = useRef("");

    useEffect(() =>
    {        
        if ((initRef.id == "init-done") && (!app_admin_users_refresh)) return;
        
        initRef.id = "init-done";

        var type = "get_active_users";
        var search_body = JSON.stringify({type});
    
        setLoading(true);
        setAppAdminUsersRefresh(false);

        console.log(`AppAdminUsersList - fetching All Active Users from ctal-get`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-get`, { method: "POST", body: search_body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: search_body })
            .then(response => response.json())
            .then(setAppAdminUsersList)
            .then(() => setLoading(false))
            .catch(setError);
    }, [app_admin_users_refresh]);

    if (app_admin_users_list.length < 0) return ( <> Fetching Active Users List </> );

    return (
        <>
            <ol class="list-group">
                { app_admin_users_list?.map( (user, i) => ( <AppAdminUsersListItem user={user} key={i}/> )) }
            </ol>
        </>
    );
}